import {asCreator, withCallbacks} from '../../../../lib/utils';
import {compose} from '../../../../utils/functions';
import {actionTypes} from '../../reducers/notificationsReducer';

export const confirmUpdateUpdatedPersonNotification = compose(
    withCallbacks,
    asCreator((data: any, id: number) => ({
        type: actionTypes.CONFIRM_UPDATE_UPDATED_PERSONS,
        payload: data,
        id
    }))
);